export const tiles = [
  {
    title: 'Cards',
    imageSrc:
      'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt4c1c0921ca5d28dc/633c5d747837bb10ac516944/original_yay-congratulations-card-a6-greeting-card.jpeg',
    url: '/cards-wrap',
    backgroundColor: '#280664',
  },
  {
    title: 'Jewellery',
    imageSrc:
      'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt0238f6bf5f84561e/633c600e4a80ba11acd39a54/original_smiley-face-90s-ring.jpeg',
    url: '/jewellery',
    backgroundColor: '#280664',
  },
  {
    title: 'Home',
    imageSrc:
      'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltbeeab4a5af72f4dd/633da8d31338101198fcc1ea/HP_dept_tiles_home.jpg',
    url: '/home',
    backgroundColor: '#280664',
  },
  {
    title: 'Beauty & wellness',
    imageSrc:
      'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltf76b6168d905bac2/633c5d665e9a09115c79b021/original_superfood-firming-serum.jpeg',
    url: '/health-beauty',
    backgroundColor: '#280664',
  },
  {
    title: 'Clothing & accessories',
    imageSrc:
      'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltaefa00197f8e0a9c/633c5d66c2df9d10fa382aab/original_orange-and-purple-striped-men-s-egyptian-cotton-socks.jpeg',
    url: '/fashion',
    backgroundColor: '#280664',
  },
  {
    title: 'Experiences',
    imageSrc:
      'https://cdn.notonthehighstreet.com/fs/d6/9d/bb88-46e9-47f5-8f5f-3d3b2c64d843/original_east-london-wine-walk-experience-for-one.jpg',
    url: '/gifts/shop-by-category/experience-gifts',
    backgroundColor: '#280664',
  },
  {
    title: 'Food & drink',
    imageSrc:
      'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt25bbeb7ea7e18adc/633c5ad887ede91113b27500/original_the-personalised-brownie-cake.jpeg',
    url: '/food-drink',
    backgroundColor: '#280664',
  },
  {
    title: 'Garden',
    imageSrc:
      'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt8981a74b342a0ab3/633c5d67eded0211051c3ad7/original_cast-iron-daffodil-and-poppy-bird-feeder-flower-dishes.jpeg',
    url: '/garden',
    backgroundColor: '#280664',
  },
  {
    title: 'Hobbies & leisure',
    imageSrc:
      'https://cdn.notonthehighstreet.com/fs/b2/c7/1732-f546-4a58-bc91-06371114c13a/original_ceramic-mushroom-painting-kit.jpg',
    url: '/hobbies-leisure',
    backgroundColor: '#280664',
  },
  {
    title: 'Party supplies',
    imageSrc:
      'https://cdn.notonthehighstreet.com/fs/95/f2/9371-3f69-42b5-8e44-aa63d9d6034e/original_large-pink-and-gold-leopard-foil-balloon.jpg',
    url: '/parties',
    backgroundColor: '#280664',
  },
  {
    title: 'Prints & art',
    imageSrc:
      'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt01128dff64b4fa93/633c5d672d122610be62c2dc/original_personalised-please-leave-by-9pm-quote-print.jpeg',
    url: '/art',
    backgroundColor: '#280664',
  },
  {
    title: 'Stationery',
    imageSrc:
      'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltd50a0aa4f798af55/633c5d67b03b6c10c5ede1fa/original_scorpio-notebook-pair.jpeg',
    url: '/stationery-department',
    backgroundColor: '#280664',
  },
  {
    title: 'Subscription gifts',
    imageSrc:
      'https://cdn.notonthehighstreet.com/fs/f6/bb/8b2e-1e0c-4ba3-bdc2-6938b2cbc3fc/original_1-month-of-fresh-pasta-gift-subscription.jpg',
    url: '/gifts/shop-by-category/subscription-gifts',
    backgroundColor: '#280664',
  },
];
